module.exports = __webpack_public_path__ + "static/media/equals-solid.a95fd3c7.svg";